import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react';
import { ConstrainMode, DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import React, { Component, Fragment } from 'react';
import Scriba from 'react-scriba';
import { DataReservation_Echeancier_Stade } from '../../data/DataReservation_Echeancier_Stade';
import { Immocom } from '../../specifique/immocom';
import { EUIDialog } from '../EUI/EUIDialog';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

export class DetailsListReservation_Echeancier_Stade extends Component {

    static defaultProps = {
        autoriserSuppression: false,
        idOperation: undefined,
        idReservation: undefined,
        idEcheancier: undefined,
        prixTTC: 0,
        stamp: undefined,
        /* --- */
        onLoad: (items) => null, // Appelée une fois les données chargées
    };

    static defaultState = {
        itemActif: {},
        items: [],
        /* --- */
        hideMessageBarFiltres: true,
        hideMessageBarWarning: true,
        hideMessageBarError: true
    };

    constructor(props) {
        super(props);
        this._columns = this._getColumns();
        this._isSortedDescending = false;
        this._sortedColumn = "pourcentageCumul";
        this.state = { ...DetailsListReservation_Echeancier_Stade.defaultState };
    };

    _creationContent = () => {
        return <DetailsList
            columns={this._columns}
            constrainMode={ConstrainMode.unconstrained}
            items={this.state.items}
            onRenderDetailsHeader={this._onRenderDetailsHeader}
            onRenderRow={this._onRenderRow}
            selectionMode={SelectionMode.none}
        />
    };

    _chargementDonnees = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement en cours..."
        });

        const { idOperation, idReservation, idEcheancier, onLoad } = this.props;
        const filtres = { idOperation, idReservation, idEcheancier };
        DataReservation_Echeancier_Stade._chargementReservation_Echeancier_Stades(filtres, this._sortedColumn, this._isSortedDescending).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const stades = responseFetch.reponseAPIobjet || [];
                const state = { items: stades };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
                if (!!onLoad && typeof onLoad === "function")
                    onLoad(stades);
            }
            else {
                const state = { items: [] };
                Immocom.onTraitementErreurAvecState(this, state, retourVerif, responseFetch);
            }
        });
    };

    _getColumns = () => {
        let columns = [
            {
                key: "pourcentageCumul",
                minWidth: 70,
                maxWidth: 70,
                name: "Cumul",
                onRender: (item) => {
                    const style = {
                        backgroundColor: "#fd0400",
                        borderRadius: "5px",
                        color: "#fff",
                        fontWeight: "600",
                        padding: "10px",
                    };
                    const { pourcentageCumul } = item;
                    const title = `${parseFloat(pourcentageCumul * 100).toFixed(10)} %`;
                    return <span style={style} title={title}>{parseFloat(pourcentageCumul * 100).toFixed(2)}&nbsp;%</span>;
                }
            },
            {
                isResizable: true,
                key: "nomStade",
                name: "Stade",
                onRender: (item) => {
                    const style = { color: "#fd0400" };
                    return <span style={style}>{item.nomStade}</span>
                }
            },
            {
                key: "pourcentageAvancementTravaux",
                minWidth: 100,
                maxWidth: 100,
                name: "Avancement",
                onRender: (item) => {
                    const { pourcentageAvancementTravaux } = item;
                    const title = `${parseFloat(pourcentageAvancementTravaux * 100).toFixed(10)} %`;
                    return <span title={title}>{parseFloat(pourcentageAvancementTravaux * 100).toFixed(2)}&nbsp;%</span>;
                }
            },
            {
                key: "montantTTCExigible",
                minWidth: 150,
                maxWidth: 150,
                name: "Montant TTC exigible",
                onRender: (item) => {
                    const { prixTTC } = this.props;
                    const { montantTTCExigible, pourcentageAvancementTravaux } = item;
                    let montant = 0;
                    if (!!montantTTCExigible) montant = montantTTCExigible;
                    else montant = prixTTC * pourcentageAvancementTravaux;
                    return <span>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(parseFloat(montant).toFixed(2), false, 2)}&nbsp;€</span>
                }
            },
            {
                key: "datePrevisionnelle",
                minWidth: 150,
                maxWidth: 150,
                name: "Date prévisionnelle",
                onRender: (item) => <span>{Scriba.date().stringDateFormatCourt(item.datePrevisionnelle)}</span>
            },
            {
                key: "dateReelle",
                minWidth: 150,
                maxWidth: 150,
                name: "Date réelle",
                onRender: (item) => <span>{Scriba.date().stringDateFormatCourt(item.dateReelle)}</span>
            }
        ];

        if (this.props.autoriserSuppression)
            columns.push({
                key: "suppression",
                minWidth: 20,
                maxWidth: 20,
                name: "",
                onRender: (item) => {
                    // Suppression du dernier stade non autorisée
                    if (item.pourcentageCumul !== 1)
                        return <IconButton iconProps={{ iconName: "Delete" }} title="Supprimer" ariaLabel="Supprimer" onClick={this._toggleDialog("Suppression", true, item)} />;
                    else return null;
                }
            });

        return columns;
    };

    _supprimer = () => {

        this._toggleDialog("Suppression", false, null)();

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Suppression en cours..."
        });

        const { idOperation, idReservation, idEcheancier } = this.props;
        const { idStade } = this.state.itemActif;

        DataReservation_Echeancier_Stade._onSuppressionReservation_Echeancier_Stades(idOperation, idReservation, idEcheancier, idStade).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null)
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this._chargementDonnees);
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });

    };

    _toggleDialog = (nomDialog, isOpen, item) => () => {
        this.setState({
            [`afficherDialog${nomDialog}`]: isOpen,
            itemActif: item || {},
        });
    };

    componentDidMount = () => {
        const { idOperation, idReservation, idEcheancier } = this.props;
        if (!!idOperation && !!idReservation && !!idEcheancier)
            this._chargementDonnees();
    };

    componentDidUpdate = (prevProps) => {
        const { idOperation, idReservation, idEcheancier, stamp } = this.props;
        if (!!idOperation && !!idReservation && !!idEcheancier)
            if (prevProps.idOperation !== idOperation || prevProps.idReservation !== idReservation || prevProps.idEcheancier !== idEcheancier || prevProps.stamp !== stamp)
                this._chargementDonnees();
    };

    render = () => {

        const { afficherDialogSuppression, itemActif } = this.state;

        return <Fragment>

            <MessageBars
                errorMessage={this.state.errorMessage}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <DetailsList
                columns={this._columns}
                constrainMode={ConstrainMode.unconstrained}
                items={this.state.items}
                selectionMode={SelectionMode.none}
            />

            <EUIDialog
                buttons={[
                    <PrimaryButton key="delete" onClick={this._supprimer} text="Supprimer" />,
                    <DefaultButton key="cancel" onClick={this._toggleDialog("Suppression", false, null)} text="Annuler" />
                ]}
                isOpen={afficherDialogSuppression}
                message="Confirmez-vous la suppression de ce stade ?"
                onDismiss={this._toggleDialog("Suppression", false, null)}
                titre="Suppression d'un stade"
            />

        </Fragment>;
    };

};